import React, {Component} from 'react';
import {Button, Input, Grid, Header, Form} from 'semantic-ui-react';
import {connect} from "react-redux";
import SaleData from "../../data/SaleData";
import {totalSale} from "../../actions/SaleTotalAction";
import {showToast} from "../../actions/ToastAction";

class DiscountForm extends Component {
    constructor(props){
        super(props);
        this.state = {
            discount_percentage: (props.total_sale.discount / props.total_sale.total_sale * 100),
            discount_money: props.total_sale.discount,
            sending: false,
            discount_observations: props.sale.discount_observations,
            disabled: true
        };

        this.handleDiscountPercentageChange = this.handleDiscountPercentageChange.bind(this);
        this.handleDiscountMoneyChange = this.handleDiscountMoneyChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
    };

    handleChange = (e, { name, value }) => this.setState({ [name]: value })

    handleDiscountPercentageChange = (event) => {
        let discount_percentage = parseFloat(event.target.value);
        if (discount_percentage >= 0) {
            let discount_money = (discount_percentage * this.props.total_sale.total_sale) / 100;
            this.setState({ discount_percentage, discount_money, discount_error: false, disabled:false});
        } else {
            this.setState({discount_error: true, disabled:true});
        }
        if (discount_percentage > 100){
            this.setState({disabled:true});
        }
        if (event.target.value.trim() === '' || isNaN(discount_percentage)){
            this.setState({ discount_error: true, disabled: true, discount_percentage: '', discount_money: ''});
        }
    };

    handleDiscountMoneyChange = (event) => {
        let discount_money = parseFloat(event.target.value);
        if (discount_money >= 0) {
            let discount_percentage = Math.round(discount_money / this.props.total_sale.total_sale * 100)
            this.setState({ discount_money, discount_percentage, discount_error: false, disabled: false });
        } else {
            this.setState({ discount_error: true, disabled: true });
        }
        if (discount_money > this.props.total_sale.total_sale) {
            this.setState({ disabled: true });
        }
        if (event.target.value.trim() === '' || isNaN(discount_money)) {
            this.setState({ discount_error: true, disabled: true, discount_money: '', discount_percentage: '' });
        }
    };

    handleSave(){
        if (this.state.discount_money >= 0 && this.state.discount_money <= this.props.total_sale.total_sale) {
            this.setState({sending: true});
            if(this.props.sale.id){
                let data = { sale: this.props.sale.id, discount: this.state.discount_money, discount_observations: this.state.discount_observations};
                SaleData.discount(data, (res) => {
                    if(res && res.update){
                        this.props.sale.discount_observations = this.state.discount_observations
                        this.props.totalSale(res.data);
                        this.props.showToast({message: 'Descuento aplicado!', type: 'success'});
                    }else{
                        this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                    }
                    this.setState({sending: false, disabled:true});
                });
            }else{
                let total = Object.assign({}, this.props.total_sale);
                total.discount = this.state.discount_money;
                total.balance = total.total_sale - this.state.discount_money;
                this.props.totalSale(total);
                this.props.showToast({message: 'Descuento aplicado!', type: 'success'});
                this.setState({sending: false, disabled:true});
            }
        } else {
            this.setState({disabled:false});
        }
    };

    render() {
        return (
            <Grid centered divided columns={2}>
                <Grid.Column textAlign='center'>
                    <Header as='h4'>Descuento en %</Header>
                    <Input
                        fluid
                        placeholder='%'
                        value={this.state.discount_percentage}
                        type='number'
                        onChange={this.handleDiscountPercentageChange}
                        error={this.state.discount_percentage > 100}
                    />
                </Grid.Column>
                <Grid.Column textAlign='center'>
                    <Header as='h4'>Descuento en $</Header>
                        <Input
                            fluid
                            placeholder='$'
                            value={this.state.discount_money}
                            onChange={this.handleDiscountMoneyChange}
                            error={this.state.discount_percentage > this.props.total_sale.total_sale}
                        />
                </Grid.Column>
                <Grid.Row>
                    <Form>
                        <Form.TextArea
                            label='Observaciones'
                            name='discount_observations'
                            placeholder='Observaciones'
                            value={this.state.discount_observations}
                            onChange={this.handleChange}
                        />
                    </Form>
                </Grid.Row>
                <Grid.Row>
                    <Button onClick={this.handleSave} loading={this.state.sending} fluid disabled={this.state.disabled}>Guardar</Button>
                </Grid.Row>
            </Grid>
        );
    }
}

function mapStateToProps(state) {
    return {
        total_sale: state.get('total_sale'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        totalSale(total) {
            dispatch(totalSale(total))
        },
        showToast(data) {
            dispatch(showToast(data));
        }
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DiscountForm);




// WEBPACK FOOTER //
// ./src/components/sale/DiscountForm.js